import { render, staticRenderFns } from "./CellResumedLink.vue?vue&type=template&id=1609f9d0"
import script from "./CellResumedLink.vue?vue&type=script&lang=js"
export * from "./CellResumedLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports